<template>
  <q-inner-loading :showing="loading" class="__C_Loading">
    <q-spinner size="50px" color="primary" :thickness="2" />
  </q-inner-loading>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CLoading',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.__C_Loading {
  //background-color: inherit;
}
</style>
